document.addEventListener("DOMContentLoaded", function () {
  var desc = document.getElementById("product-description");
  var btn = document.getElementById("pdp-read-more-toggle");
  var icon = document.getElementById("pdp-read-more-icon");

  if (desc && btn) {
    var maxHeight = 208; 

    if (desc.scrollHeight > maxHeight) {
      btn.classList.remove("hidden"); // show button
    }

    btn.addEventListener("click", function () {
      desc.classList.remove("max-h-52", "overflow-hidden");
      btn.classList.add("hidden"); // hide button after expanding
      icon.classList.add("hidden"); // hide button after expanding
    });
  }
});